<app-header></app-header>
<app-sidebar></app-sidebar>
<app-cart-mini></app-cart-mini>

<div [dir]="direction">
  <router-outlet></router-outlet>
</div>
